export { default as SectionContent } from './SectionContent';
